if (!window.customElements.get('shipping-countdown')) {
  class ShippingCountdown extends HTMLElement {
    constructor () {
      super();
      this.cutoffTime = this.getAttribute('data-cutoff-time');
      this.cutoffHour = this.cutoffTime ? this.cutoffTime.split(':')[0] : null;
      this.cutoffMinutes = this.cutoffTime ? this.cutoffTime.split(':')[1] : null;
      this.hours = this.querySelector('[data-hours]');
      this.minutes = this.querySelector('[data-minutes]');
      this.seconds = this.querySelector('[data-seconds]');
      this.modal = this.querySelector('[data-shipping-countdown-modal]');
      this.modalOpenButton = this.querySelector('[data-shipping-countdown-modal-open]');
      this.modalCloseButtons = this.querySelectorAll('[data-shipping-countdown-modal-close]');
      this.escapeHandler = (event) => {
        if (event.code === 'Escape') {
          this.closeModal();
        }
      };
    }

    connectedCallback() {
      if (!this.cutoffTime) {
        this.classList.add('hidden');
      } else {
        this.validateTime();

        if (this.modalOpenButton) {
          this.modalOpenButton.addEventListener('click', () => this.openModal());
        }

        this.modalCloseButtons.forEach((button) => button.addEventListener('click', () => this.closeModal()));
        document.addEventListener('keyup', this.escapeHandler);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('keyup', this.escapeHandler);
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }
    }

    openModal() {
      this.modal.classList.add('active');
      window.trapFocus(this.modal);
    }

    closeModal() {
      this.modal.classList.remove('active');
      window.removeTrapFocus();
    }

    validateTime() {
      const difference = this.getDifference();

      if (difference > 1) {
        this.setTime(difference);
        this.initCountdown();
      } else {
        this.classList.add('hidden');
      }
    }

    initCountdown () {
      this.countdownInterval = setInterval(() => {
        const difference = this.getDifference();

        if (difference < 1) {
          this.classList.add('hidden');
          this.stopInterval(this.countdownInterval);
          return;
        }

        this.setTime(difference);
      }, 1000);
    }

    getDifference() {
      const currentDate = new Date();
      const pstDateString = currentDate.toLocaleString('en-US', {timeZone: 'America/Los_Angeles'});
      const pstDate = new Date(pstDateString).getTime();
      const endDate = new Date(pstDateString).setHours(this.cutoffHour, this.cutoffMinutes.replace('00', 0), 0);
      const difference = endDate - pstDate;
      return difference;
    }

    setTime(difference) {
      const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);
      this.hours.innerText = hours.toString().padStart(2, '0');
      this.minutes.innerText = minutes.toString().padStart(2, '0');
      this.seconds.innerText = seconds.toString().padStart(2, '0');
    }

    stopInterval (interval) {
      this.classList.add('hidden');
      clearInterval(interval);
    }
  }

  window.customElements.define('shipping-countdown', ShippingCountdown);
}

